<template>
  <div id="app">
    <div class="container text-center mt-4 mb-4">
      <h2>Vue Great Map (PLAYGROUND)</h2>
      <hr>
      <p>
        <a href="https://www.npmjs.com/package/vue-great-nepal" rel="nofollow" class="mr-3">
          <img
            src="https://camo.githubusercontent.com/bbd489bbb5ada9a9a157cf20e4c427b70680fe0d/68747470733a2f2f696d672e736869656c64732e696f2f6e706d2f762f7675652d67726561742d6e6570616c2e737667"
            alt="NPM"
            data-canonical-src="https://img.shields.io/npm/v/vue-great-nepal.svg"
            style="max-width:100%;"
          />
        </a>
        <a href="https://standardjs.com" rel="nofollow">
          <img
            src="https://camo.githubusercontent.com/58fbab8bb63d069c1e4fb3fa37c2899c38ffcd18/68747470733a2f2f696d672e736869656c64732e696f2f62616467652f636f64655f7374796c652d7374616e646172642d627269676874677265656e2e737667"
            alt="JavaScript Style Guide"
            data-canonical-src="https://img.shields.io/badge/code_style-standard-brightgreen.svg"
            style="max-width:100%;"
          />
        </a>
      </p>

      <p style="font-size: 18px">
        Developed & maintained with
        <span class="text-danger" style="font-size:22px">&hearts;</span> by Jeevan Dhakal
      </p>

      <p>
        <a
          href="https://jeevandhakal.com.np"
          target="_blank"
          class="btn btn-primary btn-dark btn-sm text-light mr-2"
        >Visit Website</a>
        <a
          href="https://www.facebook.com/jeewandhakal25"
          target="_blank"
          class="btn btn-sm text-light mr-2"
          style="background:#4267b2"
        >Facebook</a>
        <a
          href="https://www.instagram.com/jeewandhakal25/"
          target="_blank"
          class="btn btn-sm text-light mr-2"
          style="background:#C13584"
        >Instagram</a>
        <a
          href="https://www.linkedin.com/in/jeewan-dhakal-21a849a8/"
          target="_blank"
          class="btn btn-sm text-light mr-2"
          style="background:#0073b1"
        >Linkedin</a>
      </p>
    </div>
    <div class="container">
      <MapComponent msg="Welcome to Your Vue.js App" />
    </div>

    <div class="container mt-4 mb-4 text-center">
      <p>Please let me know if you are facing any issue on using vue-great-nepal component on <a href="https://github.com/jwn25/vue-great-nepal/issues">Issues</a> or email me directly at <a href="mailto:jeewandhakal25@gmail.com">jeewandhakal25@gmail.com</a>.</p>
    </div>
  </div>
</template>

<script>
import MapComponent from "./components/MapComponent.vue";

export default {
  name: "App",
  components: {
    MapComponent
  }
};
</script>

<style>
</style>
